<template>
  <div class="view">
    <div class="content">
      <div class="condition">
        <div class="other_wrap">
          <!-- <el-button type="primary" @click="savesort">保存排序</el-button> -->
          <el-button type="primary" @click="addclassify">添加分类</el-button>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="分类名称"></el-table-column>
          <el-table-column prop="sort" label="分类排序"></el-table-column>
          <el-table-column prop="goods_number" label="商品数量"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="edit(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="del(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <goodsClassifyDialog
      :type="type"
      :classifyitem="classifyitem"
      :visible.sync="classifydialog"
      v-if="classifydialog"
      @classifysuccess="classifysuccess"
    ></goodsClassifyDialog>
  </div>
</template>
<script>
import goodsClassifyDialog from "@/components/dialog/goodsClassifyDialog.vue";
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "integralCategories",
  components: {
    goodsClassifyDialog
  },
  data() {
    return {
      formdata: {
        user: ""
      },
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      type: "",
      classifyitem: null,
      classifydialog: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    //初始化请求
    init() {
      this.page.pageindex = 1;
      this.querylist();
    },
    //查询列表
    querylist() {
      let params = {
        page: this.page.pageindex
      };
      this.axios
        .post(api.points_goods_cate_list, params)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist(); 
    },
    // 保存排序
    savesort() {},
    // 添加分类
    addclassify() {
      this.type = "add";
      this.classifydialog = true;
    },
    // 分类回调
    classifysuccess() {
      this.init();
    },
    // 编辑
    edit(row) {
      this.type = "edit";
      this.classifyitem = row;
      this.classifydialog = true;
    },
    // 删除
    del(id) {
      let params = {
        id: id
      };
      this.axios
        .post(api.goods_cate_delete, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.init();
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>